/** Routing for public results HTTP calls (fd-core-responses vs legacy cin-public-results). */

export type PublicResultsApiVersion = 'v2' | 'legacy'

export interface PublicResultsApiRouting {
  version: PublicResultsApiVersion
  baseUrl: string
  resultsEndpoint: '/results' | '/summary'
  usesNativeFilterMapping: boolean
}

/** Return the fd-core-responses public API base when configured. */
export const getPublicRestDomainV2 = (): string | undefined => {
  const configuredDomain = process.env.REACT_APP_PUBLIC_REST_DOMAIN_V2
  if (configuredDomain == null || configuredDomain === '') {
    return undefined
  }
  return configuredDomain
}

/** Return the legacy cin-public-results API base. */
export const getPublicRestDomainLegacy = (): string => {
  return process.env.REACT_APP_PUBLIC_REST_DOMAIN ?? ''
}

/** Build endpoint routing for a resolved public API version. */
export const buildPublicApiRouting = (
  version: PublicResultsApiVersion
): PublicResultsApiRouting => {
  if (version === 'v2') {
    const v2BaseUrl = getPublicRestDomainV2()
    if (v2BaseUrl == null) {
      throw new Error('REACT_APP_PUBLIC_REST_DOMAIN_V2 is not configured')
    }
    return {
      version: 'v2',
      baseUrl: v2BaseUrl,
      resultsEndpoint: '/results',
      usesNativeFilterMapping: true
    }
  }

  return {
    version: 'legacy',
    baseUrl: getPublicRestDomainLegacy(),
    resultsEndpoint: '/summary',
    usesNativeFilterMapping: false
  }
}

/** Build a project-metadata URL for the given base and survey token. */
export const buildProjectMetadataUrl = (
  baseUrl: string,
  surveyId: string
): string => {
  return `${baseUrl}/project-metadata/${surveyId}`
}
